import { render, staticRenderFns } from "./CommonLoader.vue?vue&type=template&id=a00f1a18"
import script from "./CommonLoader.vue?vue&type=script&lang=js"
export * from "./CommonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports